module.exports = __webpack_public_path__ + "src/img/bigger_viewer.97f95968.svg";